import type { ReactNode } from 'react';
import { LockKeyhole } from 'lucide-react';
import { Link } from 'react-router-dom';

import type { SnapshotContentItem } from 'services/api';
import { LIFE_PLAN_COURSE_PATH } from 'utils/lifePlanNavigation';

export const snapshotItemUnlocked = (item?: SnapshotContentItem) => Boolean(
  item?.question_exists && item.is_completed && item.is_answered,
);

export const snapshotGoalsUnlocked = (content: Record<string, SnapshotContentItem>) => (
  ['snapshot_habit1', 'snapshot_habit2', 'snapshot_habit3'].some((key) => snapshotItemUnlocked(content[key]))
);

export const SnapshotLock = ({ title, className = '', id }: {
  title: string;
  className?: string;
  id?: string;
}) => (
  <Link id={id} className={`snapshot-locked ${className}`} to={LIFE_PLAN_COURSE_PATH} aria-label={`${title} — Open Life Plan`}>
    <LockKeyhole className="snapshot-locked__illustration" aria-hidden="true" />
    <LockKeyhole className="snapshot-locked__icon" aria-hidden="true" />
    <h3>{title}</h3>
  </Link>
);

export const SnapshotContentGate = ({ item, children, ...props }: {
  item?: SnapshotContentItem;
  children: ReactNode;
  title: string;
  className?: string;
  id?: string;
}) => snapshotItemUnlocked(item) ? <>{children}</> : <SnapshotLock {...props} />;
